import { MobileVariant } from "../../../types";
import React from "react";
import { StepGraphicContainer } from "./styled";
import { StepIcon } from "./StepIcon";
import { VerticalLine } from "../../../styled";
export const StepGraphic = ({ step, active, stepCompleteIcon, stepNumber, lastStep, mobileVariant, isMobileLayout, branding, }) => {
    var _a;
    const renderVerticalLine = !lastStep &&
        (!isMobileLayout ||
            mobileVariant === MobileVariant.VERTICAL_LINE ||
            (mobileVariant === MobileVariant.VERTICAL_LINE_COMPACT && !active));
    const mobileVerticalLineHasMinHeight = isMobileLayout && !active;
    const hasSubSteps = ((_a = step.subSteps) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const nonMobileVerticalLineHasMinHeight = !isMobileLayout && (!active || !hasSubSteps);
    const verticalLineHasMinHeight = mobileVerticalLineHasMinHeight || nonMobileVerticalLineHasMinHeight;
    return (React.createElement(StepGraphicContainer, null,
        React.createElement(StepIcon, { active: active, step: step, stepCompleteIcon: stepCompleteIcon, stepNumber: stepNumber, branding: branding }),
        renderVerticalLine && (React.createElement(VerticalLine, { active: false, hasMinHeight: verticalLineHasMinHeight, branding: branding }))));
};
//# sourceMappingURL=index.js.map